import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "@phosphor-icons/react";
import { FOUNDER, ROADMAP_BLOCKS } from "@/data/founder";
import FounderBody from "@/components/FounderBody";
import ShareButton from "@/components/ShareButton";

/**
 * /about/roadmap — permalink for the founder's forward-looking roadmap.
 * The same content is available inline as a P.S. on /about/founder.
 */
export default function FounderRoadmap() {
  return (
    <div className="min-h-screen pt-28 pb-24 px-4 md:px-8 text-[color:var(--np-text)]">
      <div className="max-w-[860px] mx-auto">
        <Link
          to="/about/founder"
          data-testid="roadmap-back-link"
          className="inline-flex items-center gap-2 font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[color:var(--np-muted)] hover:text-[color:var(--np-brand)]"
        >
          <ArrowLeft size={12} weight="bold" /> Founder's letter
        </Link>

        <div className="mt-8 flex items-start gap-4">
          <span className="mt-2 inline-grid place-items-center w-11 h-11 rounded-full bg-[color:var(--np-brand)]/15 text-[color:var(--np-brand)]">
            <Compass size={20} weight="bold" />
          </span>
          <div className="min-w-0">
            <div className="font-mono-tech text-[10px] tracking-[0.4em] uppercase text-[color:var(--np-brand)]">
              / Founder's Roadmap
            </div>
            <h1 className="mt-2 font-serif-display text-4xl md:text-6xl leading-[0.95] tracking-tighter">
              What I would improve next
            </h1>
            <div className="mt-4 font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[color:var(--np-muted)]">
              {FOUNDER.name} · {FOUNDER.role}
            </div>
            <p className="mt-6 max-w-[62ch] text-[15px] md:text-[16.5px] leading-relaxed text-[color:var(--np-text-2)]">
              A short list of ideas that would take NaturePulse from a publishing site into a true
              observation database — mapped, verifiable, and open to citizen scientists everywhere.
              This is the postscript to my <Link to="/about/founder" className="text-[color:var(--np-brand)] hover:underline">founder's letter</Link>.
            </p>
          </div>
        </div>

        <div className="mt-14">
          <FounderBody blocks={ROADMAP_BLOCKS} />
        </div>

        <div className="mt-16 flex flex-wrap items-center gap-4 border-t border-black/10 pt-8">
          <div className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[color:var(--np-muted)]">
            Share this roadmap
          </div>
          <ShareButton
            title="What I would improve next — NaturePulse founder's roadmap"
            text="Tom Vellaringattu's postscript on what would take NaturePulse from a publishing site into a true observation database."
            hashtags={["NaturePulse", "CitizenScience", "Roadmap"]}
            variant="pill"
            size="sm"
            testid="roadmap-share"
            shortKind="article"
            shortId="founder-roadmap"
          />
        </div>
      </div>
    </div>
  );
}
